/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecentActivityItem } from './RecentActivityItem';
import {
    RecentActivityItemFromJSON,
    RecentActivityItemFromJSONTyped,
    RecentActivityItemToJSON,
    RecentActivityItemToJSONTyped,
} from './RecentActivityItem';

/**
 * 
 * @export
 * @interface RecentActivityResponse
 */
export interface RecentActivityResponse {
    /**
     * 
     * @type {Array<RecentActivityItem>}
     * @memberof RecentActivityResponse
     */
    items?: Array<RecentActivityItem>;
}

/**
 * Check if a given object implements the RecentActivityResponse interface.
 */
export function instanceOfRecentActivityResponse(value: object): value is RecentActivityResponse {
    return true;
}

export function RecentActivityResponseFromJSON(json: any): RecentActivityResponse {
    return RecentActivityResponseFromJSONTyped(json, false);
}

export function RecentActivityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentActivityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RecentActivityItemFromJSON)),
    };
}

export function RecentActivityResponseToJSON(json: any): RecentActivityResponse {
    return RecentActivityResponseToJSONTyped(json, false);
}

export function RecentActivityResponseToJSONTyped(value?: RecentActivityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RecentActivityItemToJSON)),
    };
}

